import { Drawer } from 'antd'
import ButtonCustom from '../../../../../../Components/ButtonCustom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFloppyDisk, faXmark } from '@fortawesome/free-solid-svg-icons'
import Input from '../../../../../../Components/CustomUi/input'
import { SetStateAction } from 'react'
import TextArea from '../../../../../../Components/CustomUi/textarea'
import { Render } from '../../../../../../Components/CustomUi/render'
import Carregando from '../../../../../../Components/CustomUi/loading'

interface PropsFormularioCargos {
  nomeCargo: string
  setNomeCargo: React.Dispatch<React.SetStateAction<string>>
  descricaoCargo: string
  setDescricaoCargo: React.Dispatch<React.SetStateAction<string>>
  editar: number
  openGaveta: boolean
  fecharGaveta: Function
  cadastrar: Function
  loadingSalvar: boolean
  loadingEditar: boolean
}

const FormularioCargos: React.FC<PropsFormularioCargos> = ({
  nomeCargo,
  setNomeCargo,
  descricaoCargo,
  setDescricaoCargo,
  editar,
  openGaveta,
  fecharGaveta,
  cadastrar,
  loadingSalvar,
  loadingEditar
}) => {
  console.log(loadingSalvar)
  return (
    <Drawer
      width={400}
      open={openGaveta}
      onClose={() => fecharGaveta()}
      closable={false}
      bodyStyle={{ padding: 0, overflowX: 'hidden' }}
      headerStyle={{ padding: '10px 10px' }}
      destroyOnClose
      title={
        <div style={{ display: 'flex', flexDirection: 'column', gap: 5, justifyContent: 'center' }}>
          <div
            style={{
              width: '100%',
              height: 35,
              borderBottom: 'thin solid var(--border-color)',
              marginLeft: -22,
            }}
          >
            <ButtonCustom
              onClick={fecharGaveta}
              type='tertiary'
              danger
              style={{ marginLeft: 10, marginTop: -10 }}
              icon={<FontAwesomeIcon icon={faXmark} />}
            >
              Fechar
            </ButtonCustom>
          </div>

          <>{editar ? 'Atualizar cargo' : 'Cadastrar cargo'}</>
        </div>
      }
      footer={
        <ButtonCustom disabled={loadingSalvar} loading={loadingSalvar} icon={<FontAwesomeIcon icon={faFloppyDisk} />} onClick={cadastrar}>
          {editar > 0 ? 'Atualizar' : 'Salvar'}
        </ButtonCustom>
      }
    >
      <Render condition={loadingEditar === false}>
        <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          padding: 10,
          gap: 10,
          boxSizing: 'border-box',
        }}
      >
        <Input
          label='Nome'
          placeholder={'Digite o nome do cargo'}
          value={nomeCargo}
          onChange={setNomeCargo}
        />
        <TextArea
          label='Descrição'
          value={descricaoCargo}
          onChange={setDescricaoCargo}
          maxHeight={200}
        />
      </div>
      </Render>
      <Render condition={loadingEditar}>
          <Carregando
            animation
            justifyContent='center'
            legenda='Carregando...'
            size={'default'}
            height={600}
          />
        </Render>
    </Drawer>
  )
}

export default FormularioCargos